function getSelectedVariantData() {
  const radios = document.querySelector('variant-radios');
  if (!radios) return null;

  const jsonScript = radios.querySelector('script[type="application/json"]');
  if (!jsonScript) return null;

  let variants;
  try {
    variants = JSON.parse(jsonScript.textContent);
  } catch (e) {
    return null;
  }

  const checkedRadio = radios.querySelector('input[type="radio"]:checked');
  if (!checkedRadio) return null;

  const variant = variants.find(v => v.title === checkedRadio.value) ||
                  variants.find(v => v.option1 === checkedRadio.value);
  if (!variant) return null;

  const qty = parseInt(variant.title.match(/\d+/)?.[0] || '0', 10);
  return { price: variant.price, qty };
}

function money(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function updateAllSummaries() {
  const variantData = getSelectedVariantData();
  if (!variantData) return;

  document.querySelectorAll('product-form').forEach((form) => {
    const quantityInput = form.querySelector('.quantity-input');
    const subEl = form.querySelector('.product-form__submit-sub');
    if (!quantityInput || !subEl) return;

    const packCount = parseInt(quantityInput.value, 10) || 1;
    const total = variantData.price * packCount;

    subEl.textContent = `${packCount} pack${packCount > 1 ? 's' : ''} of ${variantData.qty} \u00b7 ${money(total)}`;
  });
}

document.addEventListener('change', (e) => {
  if (e.target.matches('.quantity-input') || e.target.matches('input[type="radio"]')) {
    updateAllSummaries();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateAllSummaries);
} else {
  updateAllSummaries();
}